import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { BellRing, Plus, ShieldCheck, ChevronRight } from "lucide-react";
import { useApp } from "../context/AppContext";
import { enablePush, disablePush, pushStatus } from "../lib/push";
import { api } from "../lib/api";
import { PageHeader, Section } from "../components/bits";
import StructureForm from "./StructureForm";

function PushRow() {
  const [st, setSt] = useState("…");
  useEffect(() => { pushStatus().then(setSt); }, []);
  const toggle = async () => {
    try {
      if (st === "on") { await disablePush(); setSt("off"); toast.success("Notifications désactivées"); }
      else { await enablePush(); setSt("on"); await api.post("/push/test"); toast.success("Notifications activées"); }
    } catch (e) { toast.error(e.message); }
  };
  const label = { on: "Activées", off: "Désactivées", denied: "Bloquées", unsupported: "Non supportées" }[st] || st;
  return (
    <button onClick={toggle} className="card tap flex w-full items-center gap-3 px-4 py-4 text-left" data-testid="push-toggle-btn">
      <BellRing className="h-5 w-5 text-teal-700" />
      <span className="flex-1 font-semibold">Notifications</span>
      <span className={`rounded-full px-3 py-1 text-xs font-bold ${st === "on" ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-600"}`} data-testid="push-status">{label}</span>
    </button>
  );
}

function LinkRow({ to, icon: Icon, label, testid }) {
  return (
    <Link to={to} className="card tap flex items-center gap-3 px-4 py-4" data-testid={testid}>
      <Icon className="h-5 w-5 text-teal-700" /><span className="flex-1 font-semibold">{label}</span><ChevronRight className="h-4 w-4 text-slate-300" />
    </Link>
  );
}

export default function SettingsPage() {
  const { user, isOwner } = useApp();
  return (
    <div data-testid="settings-page">
      <PageHeader title="Paramètres" back="/" />
      <Section title="Sur ce téléphone">
        <PushRow />
        <div className="card mt-3 p-4 text-sm text-slate-600" data-testid="install-help">
          <div className="mb-1 font-bold text-slate-900">Installer l'application</div>
          <p><b>iPhone (Safari)</b> : touchez Partager <span aria-hidden>⬆️</span> puis « Sur l'écran d'accueil ». Les notifications ne fonctionnent sur iPhone qu'une fois l'app installée (iOS 16.4 ou plus).</p>
          <p className="mt-2"><b>Android (Chrome)</b> : menu ⋮ puis « Installer l'application ».</p>
        </div>
      </Section>
      {isOwner && <Section title="Mon équipe"><StructureForm edit embedded /></Section>}
      {(user.can_create_structures || user.is_superadmin) && (
        <Section title="Autres">
          <div className="space-y-2">
            <LinkRow to="/structure/nouvelle" icon={Plus} label="Créer une autre équipe" testid="settings-create-structure-link" />
            {user.is_superadmin && <LinkRow to="/admin" icon={ShieldCheck} label="Super administration" testid="settings-admin-link" />}
          </div>
        </Section>
      )}
    </div>
  );
}
